import type { AccountEntity } from "@dealer-center/ddc-api-account-interface";
import { Card, CardContent } from "@dealer-center/core-components";
import { DealerCodeTable } from "./dealer-code-table";
import { useOutletContext } from "react-router-dom";
import { useDealerCodeModals } from "../modals";

export function DashboardDealerCodes() {
  const { accountEntity } = useOutletContext<{
    accountEntity: AccountEntity;
  }>();
  const dealerCodeModals = useDealerCodeModals();
  return (
    <>
      <Card
        content={
          <CardContent>
            <DealerCodeTable accountEntity={accountEntity} />
          </CardContent>
        }
      />
      {dealerCodeModals.modal}
    </>
  );
}
